import { Container, AppBar as MuiAppBar, AppBarProps as MuiAppBarProps, Toolbar, styled } from "@mui/material";

import { HasPermission } from "@/permissions";
import { Logo } from "./Icons";
import { TenantSelector } from "./components/TenantSelector/TenantSelector";
import { TitlesHeader } from "./components/TitlesHeader/TitlesHeader";
import { UserMenu } from "./components/UserMenu/UserMenu";

const drawerWidth = 240;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== "open",
})<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const ResponsiveAppBar = () => (
  <AppBar position="fixed" sx={{ height: "72px", boxShadow: "unset" }}>
    <Container maxWidth={false} sx={{ ml: "auto", mr: "auto", height: "72px", pl: "0!important", pr: "22px" }}>
      <Toolbar disableGutters sx={{ height: "72px" }}>
        <Logo />
        <HasPermission permission={["super_admin"]}>
          <TenantSelector />
        </HasPermission>
        <TitlesHeader />
        <UserMenu />
      </Toolbar>
    </Container>
  </AppBar>
);

export default ResponsiveAppBar;
